import React, { useState, useContext } from 'react';
import {
  Popover,
  TextStyle,
  DisplayText,
  Modal,
  Button,
  ResourceItem,
  Badge,
  ActionList
} from '@superops/ui-design-system';
import {
  getTranslatedText,
  toast,
  AccessControl,
  AppContext,
  isAuthorised
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getProcessedIntegrationOptions } from '@nile/components/src/Utils/integrationProcessing';
import { SVGIcon } from '@superops/super-icons';
import { RMMClient, INITIATE_REMOTE_SESSTION } from '@nile/graphql';
import { RUN_LIVE_ACTION } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import { useFlags } from 'launchdarkly-react-client-sdk';
const lokaliseData = function(name: string) {
  switch (name) {
    case 'SUPEROPS_SPLASH_TOP':
    case 'SPLASH_TOP':
      return 'splashtop.wfh';
    case 'ISL':
      return 'isl.wfh';
    default:
      return '';
  }
};

function AssetActionsCell(props) {
  const { cell, intl, darkBg, ticketInsights = false } = props;
  const flags = useFlags();

  const appContext = useContext(AppContext);
  const [active, setActive] = useState(false);
  const currentUser = appContext?.user || {};
  const roleFeatures = currentUser?.role?.roleFeatureList || [];
  const remoteDesktopAddOnEnabledStatus =
    currentUser.remoteDesktopAddOnEnabledStatus;
  const {
    configuredIntegrations,
    isAssetInClientPortal,
    isPatchView
  } = cell?.column;

  const asset = isPatchView
    ? cell?.row.original.workStation
    : cell?.row.original;

  const SPLASHTOP_INTEGRATION_REFID = '1004';
  const ISL_INTEGRATION_REFID = '1012';
  const [remotePopoverActive, setRemotePopoverActive] = useState(false);

  const splashTopWfh =
    configuredIntegrations.find(
      (s) => s.integrationRefId === SPLASHTOP_INTEGRATION_REFID
    ) || {};
  const islWfh =
    configuredIntegrations.find(
      (s) => s.integrationRefId === ISL_INTEGRATION_REFID
    ) || {};
  const isSplashTopwfhActive =
    asset?.splashtopIntegrated &&
    !splashTopWfh?.ownLicense &&
    asset?.remoteDesktopEnabledStatus?.SUPEROPS_SPLASH_TOP &&
    splashTopWfh?.activated
      ? splashTopWfh.integrationId
      : '';
  const isIslWfhActive =
    asset?.islIntegrated &&
    remoteDesktopAddOnEnabledStatus.ISL_ONLINE_WORK_FROM_HOME;
  const wfhList = configuredIntegrations.filter((v) => {
    if (v.integrationId === islWfh.integrationId && isIslWfhActive) {
      return true;
    }
    if (
      v.integrationId === isSplashTopwfhActive &&
      remoteDesktopAddOnEnabledStatus.SPLASHTOP_WORK_FROM_HOME
    ) {
      return true;
    }
    return false;
  });
  const isEnableRequesterRemote =
    asset?.client?.mappedToWFH && (isSplashTopwfhActive || isIslWfhActive);

  const toggleRemotePopover = () => {
    setRemotePopoverActive(!remotePopoverActive);
  };

  const [rebootConfirmation, setRebootConfirmation] = useState(false);

  const toggleRebootConfirmation = () => {
    setRebootConfirmation(!rebootConfirmation);
  };

  const remoteActionsIcon = (
    enableOption: boolean,
    showNotficationIcon: boolean = true
  ) => {
    return !ticketInsights ? (
      <div className="cursor-pointer">
        <div
          className={`fx center ${
            !enableOption ? 'disabled cursor-not-allowed' : ''
          }`}
          onClick={enableOption ? toggleRemotePopover : () => {}}
        >
          <SVGIcon name="Actions" color={darkBg ? 'white' : 'currentColor'} />
        </div>
      </div>
    ) : (
      <Button
        onClick={enableOption ? toggleRemotePopover : () => {}}
        disabled={!enableOption}
        icon={<SVGIcon name="Actions" />}
      />
    );
  };

  const getIconName = (name) => {
    switch (name) {
      case 'TEAM_VIEWER':
        return 'teamViewer';
      case 'SUPEROPS_SPLASH_TOP':
      case 'SPLASH_TOP':
        return 'Splashtop';
      case 'CONNECT_WISE_CONTROL':
        return 'connectWise';
      case 'ISL':
        return 'Isl';
      default:
        break;
    }
  };

  const renderIntegrationOptions = (asset) => {
    const options = getProcessedIntegrationOptions({
      configuredIntegrations,
      asset,
      intl
    });

    const handleOptionClick = (selectedOption, triggerToggle) => {
      if (isAssetInClientPortal && !isEnableRequesterRemote) {
        return;
      }
      RMMClient.mutate({
        mutation: INITIATE_REMOTE_SESSTION,
        variables: {
          assetId: asset.assetId,
          integrationType: selectedOption.name
        }
      })
        .then((res) => {
          window.open(res.data.initiateRemoteSession, selectedOption.name);
          !triggerToggle && toggleRemotePopover();
        })
        .catch(() => {
          !triggerToggle && toggleRemotePopover();
        });
    };

    const installSplashtop = () => {
      toggleRemotePopover();
      RMMClient.mutate({
        mutation: RUN_LIVE_ACTION,
        variables: {
          actionType: 'INSTALL_SPLASHTOP',
          assetId: asset.assetId,
          input: {
            windowsId: asset.assetId
          }
        }
      })
        .then((res) => {
          if (res?.data?.runLiveAction) {
            toast('success', 'asset.install.splashtop.success.message');
          } else {
            toast('error', 'asset.install.splashtop.fail.message');
          }
        })
        .catch(() => {
          toast('error', 'asset.install.splashtop.fail.message');
        });
    };

    const installIsl = () => {
      toggleRemotePopover();
      RMMClient.mutate({
        mutation: RUN_LIVE_ACTION,
        variables: {
          actionType: 'INSTALL_ISL',
          assetId: asset.assetId,
          input: {
            windowsId: asset.assetId
          }
        }
      })
        .then((res) => {
          if (res?.data?.runLiveAction) {
            toast('success', 'asset.install.isl.success.message');
          } else {
            toast('error', 'asset.install.isl.fail.message');
          }
        })
        .catch(() => {
          toast('error', 'asset.install.isl.fail.message');
        });
    };

    const rebootAsset = () => {
      RMMClient.mutate({
        mutation: RUN_LIVE_ACTION,
        variables: {
          actionType: 'REBOOT',
          assetId: asset.assetId,
          input: {
            windowsId: asset.assetId
          }
        }
      })
        .then((res) => {
          if (res) {
            toast('success', 'app.toast.asset.detail.reboot.success');
          } else {
            toast('error', 'app.toast.asset.detail.reboot.fail');
          }
          toggleRemotePopover();
        })
        .catch(() => {
          toast('error', 'app.toast.asset.detail.reboot.fail');
        });
    };

    const assetActionAuthorised = isAuthorised(
      roleFeatures,
      'assetActions.allow'
    );

    const showPopup = asset.rebootNeeded || (options && options.length > 0);

    const [showRootCasePopup, setShowRootCasePopup] = useState(false);

    const showWarningNotification =
      asset.rebootNeeded && flags.assetRebootStatus && assetActionAuthorised;

    if (isAssetInClientPortal) {
      return (
        <div className="flex actr jctr">
          <Popover
            active={active}
            onClose={() => setActive(false)}
            activator={
              <Button
                plain
                onClick={() => setActive(!active)}
                disabled={!isEnableRequesterRemote || !wfhList.length}
                icon={<SVGIcon name={'Actions'} />}
              />
            }
            customClassName="w280"
            preferredAlignment="left"
          >
            <ActionList
              actionRole="menuitem"
              items={wfhList.map((item) => ({
                content: item?.integrationId ? (
                  <div
                    className="flex actr g10"
                    onClick={() =>
                      handleOptionClick(
                        {
                          name: item?.integrationId
                        },
                        'IgnoreToggle'
                      )
                    }
                  >
                    <SVGIcon name={getIconName(item?.integrationId)} />
                    <TextStyle weight="Regular">
                      {getTranslatedText(
                        intl,
                        lokaliseData(item?.integrationId)
                      )}
                    </TextStyle>
                  </div>
                ) : null
              }))}
            />
          </Popover>
        </div>
      );
    }

    const showInstallSplashtop =
      !splashTopWfh.ownLicense &&
      asset?.remoteDesktopEnabledStatus?.SUPEROPS_SPLASH_TOP &&
      flags.splashtopInstall &&
      splashTopWfh?.activated;
    const showInstallISL = asset?.remoteDesktopEnabledStatus?.ISL;
    return (
      <>
        <Popover
          active={remotePopoverActive}
          activator={remoteActionsIcon(showPopup, showWarningNotification)}
          onClose={toggleRemotePopover}
          customClassName="w280"
          preferredAlignment="left"
        >
          {(showInstallSplashtop || showInstallISL || asset?.rebootNeeded) && (
            <div className="flex pt-5 pb-5 pl10 pr10">
              <DisplayText weight="Regular">
                <span className="uppercase">
                  {getTranslatedText(intl, 'common.quick.actions')}
                </span>
              </DisplayText>
            </div>
          )}

          {flags.assetRebootStatus && (
            <AccessControl
              roleToCheck="assetActions.allow"
              render={
                <>
                  {asset?.rebootNeeded && (
                    <Popover
                      active={showRootCasePopup}
                      activator={
                        <ResourceItem gutter="xs" verticalAlignment="center">
                          <div
                            onClick={toggleRebootConfirmation}
                            onMouseEnter={() => setShowRootCasePopup(true)}
                            onMouseLeave={() => setShowRootCasePopup(false)}
                          >
                            <div className="flex actr p10">
                              <TextStyle weight="Regular">
                                {getTranslatedText(
                                  intl,
                                  'asset.details.action.reboot'
                                )}
                                <span className="ml-10 vertical-align-text-top">
                                  <SVGIcon
                                    name="WarningIcon"
                                    size="sm"
                                    color="#f07602"
                                  />
                                </span>
                              </TextStyle>
                            </div>
                          </div>
                        </ResourceItem>
                      }
                      onClose={() => setShowRootCasePopup(false)}
                      preferredAlignment="right"
                      fixed
                    >
                      <div className="p10">
                        <span className="mb-5 ml-10">
                          <TextStyle variation="subdued">
                            {getTranslatedText(
                              intl,
                              'rmm.reboot.status.reason.heading'
                            )}
                          </TextStyle>
                        </span>
                        {asset.rebootCause.map(
                          (cause: { key: string }, idx: number) => (
                            <div className="p5 fx actr" key={idx}>
                              <span className="mr-10 fx actr">
                                <SVGIcon
                                  name="About"
                                  color="#f07602"
                                  size="sm"
                                />
                              </span>
                              <DisplayText>
                                {getTranslatedText(intl, cause.key)}
                              </DisplayText>
                            </div>
                          )
                        )}
                      </div>
                    </Popover>
                  )}
                </>
              }
            />
          )}

          {showInstallISL && (
            <AccessControl
              roleToCheck="remoteDesktop.allow"
              render={
                <ResourceItem
                  onClick={() => {
                    installIsl();
                  }}
                  key="install-splashtop"
                  gutter="xs"
                  verticalAlignment="center"
                >
                  <div className="p10 flex actr g10">
                    <SVGIcon name="Isl" />
                    <TextStyle weight="Regular">
                      <FormattedMessage id="integrations.install.isl.online" />
                    </TextStyle>
                  </div>
                </ResourceItem>
              }
            />
          )}
          {showInstallSplashtop && (
            <AccessControl
              roleToCheck="remoteDesktop.allow"
              render={
                <ResourceItem
                  onClick={() => {
                    installSplashtop();
                  }}
                  key="install-splashtop"
                  gutter="xs"
                  verticalAlignment="center"
                >
                  <div className="p10 flex actr g10">
                    <SVGIcon name="Splashtop" />
                    <TextStyle weight="Regular">
                      <FormattedMessage id="asset.install.splashtop" />
                    </TextStyle>
                  </div>
                </ResourceItem>
              }
            />
          )}

          {options && options?.length > 0 && (
            <AccessControl
              roleToCheck="remoteDesktop.allow"
              render={
                <>
                  <div className=" pt-5 pb-5 pl10 pr10">
                    <DisplayText weight="Regular">
                      <span className="uppercase">
                        {getTranslatedText(
                          intl,
                          'admin.integrations.otherIntegrations'
                        )}
                      </span>
                    </DisplayText>
                  </div>
                  {options?.map((option: any, idx: Number) => (
                    <ResourceItem
                      onClick={() => {
                        handleOptionClick(option);
                      }}
                      gutter="xs"
                      verticalAlignment="center"
                      key={idx}
                    >
                      <div className="p10 flex actr g10">
                        <SVGIcon name={getIconName(option?.name)} />
                        <TextStyle weight="Regular">{option?.label}</TextStyle>
                      </div>
                    </ResourceItem>
                  ))}
                </>
              }
            />
          )}
        </Popover>
        <Modal
          open={rebootConfirmation}
          onClose={() => toggleRebootConfirmation()}
          variant="confirmation"
          title={<FormattedMessage id="asset.reboot.confirmation.heading" />}
          primaryAction={{
            content: (
              <div className="flex actr ">
                <SVGIcon name="Reboot" />
                <div className="ml8">
                  <FormattedMessage id="asset.details.reboot.modal.primaryText" />
                </div>
              </div>
            ),
            onAction: () => {
              toggleRebootConfirmation();
              rebootAsset();
            }
          }}
          secondaryActions={[
            {
              content: <FormattedMessage id="common.cancel" />,
              onAction: () => toggleRebootConfirmation()
            }
          ]}
        >
          <div className="mt-10">
            <FormattedMessage id="asset.reboot.confirmation.description" />
          </div>
        </Modal>
      </>
    );
  };

  return (
    <div className="position-relative">{renderIntegrationOptions(asset)}</div>
  );
}

export default injectIntl(AssetActionsCell);
